import { memo } from 'react';

import { FiMessageSquare, FiEdit3 } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import formatDistanceToNowStrict from 'date-fns/formatDistanceToNowStrict';
import parseISO from 'date-fns/parseISO';
import { enUS, ptBR } from 'date-fns/locale';

import { useEventfy, useNewsFeedQuery } from '@hooks';
import { selectIsNewsFeedEnable } from '@hooks/useEventfy/selectors';
import { Avatar } from '@components';

import * as S from './styles';

const FeedPanel = () => {
  const isNewsFeedEnabled = useEventfy(selectIsNewsFeedEnable);
  const newsfeedQuery = useNewsFeedQuery(isNewsFeedEnabled);
  const { t, i18n } = useTranslation();

  if (!isNewsFeedEnabled) return null;

  const posts = newsfeedQuery.isSuccess
    ? newsfeedQuery.data.pages[0]?.data?.slice(0, 3) || []
    : [];

  if (newsfeedQuery.isLoading) return null;

  return (
    <S.Container>
      <S.Header>
        <S.HeaderLeft>
          <FiMessageSquare size={14} />
          <h3>Feed</h3>
        </S.HeaderLeft>
        <S.ViewAllLink to="/newsfeed">
          {t('pages.lobby.newsfeedComplete') || 'Ver tudo'}
        </S.ViewAllLink>
      </S.Header>

      {!posts.length && (
        <S.EmptyState>
          <FiMessageSquare size={32} />
          <strong>Nenhuma publicação ainda</strong>
          <span>Seja o primeiro a publicar e iniciar a conversa!</span>
        </S.EmptyState>
      )}

      {posts.map((post) => {
        const user = post.user.data;
        const timeAgo = formatDistanceToNowStrict(parseISO(post.created_at), {
          locale: i18n.language === 'en' ? enUS : ptBR,
          addSuffix: false,
        });

        return (
          <S.FeedItem key={`feed-${post.id}`}>
            <S.FeedAvatar>
              <Avatar src={user.avatar} alt={user.name} />
              <S.TypeIcon>
                <FiEdit3 size={9} />
              </S.TypeIcon>
            </S.FeedAvatar>
            <S.FeedContent>
              <p>
                <strong>{user.name.split(' ')[0]}</strong>{' '}
                <span>{t('pages.lobby.newsfeedPosted')}</span>
              </p>
            </S.FeedContent>
            <S.FeedTime>{timeAgo}</S.FeedTime>
          </S.FeedItem>
        );
      })}
    </S.Container>
  );
};

export default memo(FeedPanel);
